import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogConfigInterface} from 'appShared/components/dialog';
import {AddExchangeForm} from 'appEntries/panel/forms';
import {ApiError, ExchangeModel, SesService} from '@spa/api';
import {ExchangeFormErrorStatesEnum} from 'appEntries/panel/enums';
import {ExchangeAddMessages} from 'appAssets/messages';
import {AlertsService} from 'appShared/services';
import {PanelBaseMarketDataFormDialogComponent} from 'appEntries/panel/dialogs/ses/panel-base-market-data-form-dialog.component';

@Component({
    selector: 'app-exchange-edit',
    templateUrl: './exchange-edit.component.html',
    styleUrls: ['./exchange-edit.component.scss']
})
export class ExchangeEditComponent extends PanelBaseMarketDataFormDialogComponent<ExchangeEditComponent> {
    private readonly agreementTypes: Record<string, string>;

    public exchange: ExchangeModel;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            agreementTypes: Record<string, string>,
            exchange: ExchangeModel
        },
        private readonly sesService: SesService,
        protected alertsService: AlertsService,
        public dialogRef: MatDialogRef<ExchangeEditComponent>,
    ) {
        super(dialogRef, alertsService);
        this.config = data.config;
        this.exchange = data.exchange;
        this.agreementTypes = data.agreementTypes;
    }

    initForm(): void {
        this.form = new AddExchangeForm(this.sesService, this.agreementTypes, this.exchange);
        this.form.initForm();
    }

    getSuccessFormMessage(): string {
        return ExchangeAddMessages.ExchangeUpdateSucceed.message;
    }

    getErrorMessageByApiError(error: ApiError): string {
        if (error.status === ExchangeFormErrorStatesEnum.UpdateExchangeFailed) {
            return ExchangeAddMessages.ExchangeUpdateFailed.message;
        }

        return ExchangeAddMessages.UnknownError.message;
    }
}
